// import React from "react";
// import "./Card.css";

// const Card = ({ image, alt }) => {
//   return (
//     <div className="card">
//       {image && <img src={image} alt={alt || "Card Image"} className="card-image" />}
//     </div>
//   );
// };

// export default Card;


// import React, { useState } from "react";
// import "./Card.css";

// const Card = ({ image, alt, title, description }) => {
//   const [showPopup, setShowPopup] = useState(false);

//   const handleOpen = () => setShowPopup(true);
//   const handleClose = () => setShowPopup(false);

//   return (
//     <>
//       {/* Small card */}
//       <div className="card" onClick={handleOpen}>
//         {image && <img src={image} alt={alt || "Card Image"} className="card-image" />}
//         {title && <h3 className="card-title">{title}</h3>}
//       </div>

//       {/* Popup */}
//       {showPopup && (
//         <div className="popup-overlay" onClick={handleClose}>
//           <div className="popup-content" onClick={(e) => e.stopPropagation()}>
//             <button className="popup-close" onClick={handleClose}>
//               &times;
//             </button>
//             <div className="popup-body">
//               <img src={image} alt={alt || "Card Image"} className="popup-image" />
//               <div className="popup-text">
//                 <h2>{title}</h2>
//                 <p>{description}</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Card;

import React, { useState } from "react";
import "./Card.css";


const Card = ({ image, alt, title, description }) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleOpen = () => setShowPopup(true);
  const handleClose = () => setShowPopup(false);

  return (
    <>
      {/* Small card */}
      <div className="card" onClick={handleOpen}>
        {image && <img src={image} alt={alt || "Card Image"} className="card-image" />}
        <p className="card-title">{title}</p>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay" onClick={handleClose}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleClose}>
              &times;
            </button>
            <div className="popup-body">
              {/* Left: text */}
              <div className="popup-text">
                <h2>{title}</h2>
                <p>{description}</p>
              </div>

              {/* Right: image */}
              <div className="popup-img">
                <img src={image} alt={alt || "Card Image"} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
